import { isDev, isLocal } from '@/constant/index';

export const WORK_APPROVAL_TAB = 'approval';
export const WORK_MEETING_NOTES_TAB = 'meeting-notes';

export const SOCIAL_AX_LOUNGE_GROUP_ID =
  isLocal || isDev ? '69d4aef4860dcd4832c80460' : '69df280d32280a5e2665023a';

/** 소셜 SNB 상단 배너 캐러셀에 슬라이드로 노출하는 게시글 */
export const SOCIAL_SNB_BANNER_BOARD_ID =
  isLocal || isDev ? '6a41d216f2a2bb974d07e847' : '6a6828cc2d4d3e8ef307b059';

export const PAGE_URL = {
  LOGIN: '/login',
  MAIN: '/',
  HOME_MOBILE: '/m',
  APPROVAL_MOBILE: '/m/approval',
  HOME: '/?tab=home',
  SOCIAL: '/?tab=social',
  WORK_APPROVAL: `/?tab=work&subtab=${WORK_APPROVAL_TAB}`,
  WORK_MEETING_NOTES: `/?tab=work&subtab=${WORK_MEETING_NOTES_TAB}`,
  APPROVAL_CREATE: (approvalType: number) =>
    `/intranet/approval/create?apv_type=${approvalType}`,
  BOARD_DETAIL: (documentId: string) => `/board/${documentId}`,
  PERSON: '/#person_open',
  COMMUNITY: '/#F&F 공지사항_open',
  NEWS: '/#F&F News_open',
  TREND: '#Trend & issue_open',
  LIFE_HTML: '/html/life.html',
  GPT_EMPLOYEE: '/gpt/employee',
  ORGANIZATION: '/organization',
  F_TOK: '/app/f-talk',
  FORBIDDEN: '/403',
  NOT_FOUND: '/404',
  // 인테리어 공사비 적정성 분석 — 매장 목록(INTERIOR)과 등록/수정 폼 두 화면뿐이다.
  //   구 /interior/simulation · /interior/stores 는 목록으로 통합돼(PORTAL-13055)
  //   라우트만 리다이렉트로 남겼다 — 새로 링크할 곳이 없어 상수는 두지 않는다.
  // 다른 사내 앱(f-talk · ai-marketing-expense · live-lexical-room)과 같이 /app 하위에
  //   둔다 (PORTAL-13581). 구 경로(/interior/*)는 리다이렉트 스텁으로 남겨 둔다 —
  //   결재 문서·북마크에 박힌 링크가 죽지 않게.
  INTERIOR: '/app/interior',
  INTERIOR_STORES_NEW: '/app/interior/stores/new',
  // 유사매장(실적 인덱스) 현황 — 목록 · 상세 (2026-09-09). 등록/수정 화면은 추후 추가.
  INTERIOR_SIMILAR: '/app/interior/similar',
  INTERIOR_SIMILAR_DETAIL: (id: string) =>
    `/app/interior/similar/${encodeURIComponent(id)}`,
  // 파일 뷰어
  FILE_VIEWER: '/file-viewer',
  // 포탈 캘린더 (PORTAL-12626). WORK 탭 소속 — GNB 하이라이트는
  //   hooks/main/useGNBTabs.ts 의 WORK.selectedPath 가 잡는다
  CALENDAR: '/calendar',
  // 모바일 캘린더 (M1). RN 앱 하단 탭에서 웹뷰로 연다 (Q-39)
  CALENDAR_MOBILE: '/m/calendar',
};

export const MS_PASSWORD_URL =
  'https://account.activedirectory.windowsazure.com/ChangePassword.aspx';

/**
 * SA 바로가기. SA New Portal 전환으로 eas(-dev).fnf.co.kr 에서 smart-portal 도메인으로
 * 옮겼다 (PORTAL-14499 / ITSM-42253). F&CO 는 전환 대상이 아니라 EAS_FNCO_URL 을 그대로 쓴다.
 */
export const EAS_URL = isDev
  ? 'https://fnfdev.smart-portal.co.kr/'
  : 'https://fnf.smart-portal.co.kr/';

export const EAS_FNCO_URL = 'https://eas.fnco.kr/';

/**
 * SA-AUTO (전표 자동화). App Box > 회계 에 등록된 주소와 같다 (PORTAL-13953).
 * dev 주소는 dev 포탈의 App Box 실물에서 확인했다. 분기 기준은 위 EAS_URL 과 맞춘다.
 */
export const SA_AUTO_URL = isDev
  ? 'https://sa-auto.dev.fnf.co.kr/'
  : 'https://sa-auto.fnf.co.kr/';

/**
 * 지식 위키(knowledge-ai) 링크.
 * 로컬/dev(develop) 는 개발 인스턴스, stg/prod(staging·main) 는 int-ax 인스턴스.
 */
export const WIKI_URL =
  isLocal || isDev
    ? 'https://knowledge-ai.int-prcs-dev.fnf.co.kr'
    : 'https://knowledge-ai.int-ax.fnf.co.kr';

/**
 * 건강관리실 예약 (PORTAL-14158 / ITSM-40420).
 * 포탈 외부에 별도로 운영되는 페이지라 환경별 분기가 없다.
 */
export const HEALTH_CARE_BOOKING_URL = 'https://fnf-wellness-booking.web.app/';
